var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(765 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -74.3L64.4 -37.2L64.4 37.2L0 74.3L-64.4 37.2L-64.4 -37.2Z",
    stroke: "#FED242",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123 519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -25L21.7 -12.5L21.7 12.5L0 25L-21.7 12.5L-21.7 -12.5Z",
    stroke: "#FED242",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -50L43.3 -25L43.3 25L0 50L-43.3 25L-43.3 -25Z",
    stroke: "#FED242",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(656 399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -45L39 -22.5L39 22.5L0 45L-39 22.5L-39 -22.5Z",
    stroke: "#FED242",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(436 365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -43L37.2 -21.5L37.2 21.5L0 43L-37.2 21.5L-37.2 -21.5Z",
    stroke: "#FED242",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92 252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -41L35.5 -20.5L35.5 20.5L0 41L-35.5 20.5L-35.5 -20.5Z",
    stroke: "#FED242",
    fill: "none",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.f076e6934f3c9a27b0eff3edf6be6818.svg";
export { ForwardRef as ReactComponent };